import { jwtDecode } from "jwt-decode";
import React ,{ createContext, useState } from "react";

const AuthContext=createContext()
 function AuthProvider({children}){  
   const [token,setToken]=useState(localStorage.getItem("Virtual_business_token") || null)
   
   const login=(token)=>{
      localStorage.removeItem("token")
      localStorage.setItem("Virtual_business_token",token)
      setToken(token)
   }
   const logOut=(token)=>{  
      localStorage.removeItem("Virtual_business_token")
      setToken(null)    
   
   }

   return (
    <div>
        <AuthContext.Provider value={{token,login,logOut}}>
          {children}
        </AuthContext.Provider>
    </div>
   )
}
export {AuthContext,AuthProvider}